import {
  cannedResponses,
  customerSelectInstagramConnection,
  detailsSubmit,
  disconnectOrReconnectIG,
  getAvailableInstagramConnections,
  getLinkedinAccountDetails,
  igStatus,
  instagramDirectConnect,
  linkedinConnect,
  linkedinReconnect,
  linkedinStatus,
  notifications,
  notificationsRead,
  registerWebhookLinkedin,
  saveEmailSettings,
  updateOrDeleteCannedMessage,
  userDetails,
} from '@/constants/endpoints';

import { APIClient } from '@/lib/ApiClient';

const apiClient = new APIClient();

export function fetchUserDetails() {
  return apiClient.get(userDetails, null, true);
}

export function checkIGConnectionStatus() {
  return apiClient.get(igStatus, null, true);
}

export function disconnectInstagram() {
  return apiClient.delete(disconnectOrReconnectIG, null, true);
}

export function reconnectInstagram() {
  return apiClient.delete(
    `${disconnectOrReconnectIG}?action=reconnect`,
    null,
    true
  );
}

export function fetchCannedMessages() {
  return apiClient.get(cannedResponses, null, true);
}

export function createCannedMessage(data) {
  return apiClient.create(
    cannedResponses,
    {
      shortcut: data.shortcut,
      message: data.message,
      global: data.global,
    },
    true
  );
}

export function updateCannedMessage(cannedResponseId, data) {
  return apiClient.update(
    updateOrDeleteCannedMessage(cannedResponseId),
    {
      shortcut: data.shortcut,
      message: data.message,
      global: data.global,
    },
    true
  );
}

export function deleteCannedMessage(cannedResponseId) {
  return apiClient.delete(
    updateOrDeleteCannedMessage(cannedResponseId),
    null,
    true
  );
}

// Notifications
export function fetchNotifications() {
  return apiClient.get(notifications, null, true);
}

export function markNotificationAsRead(action, notificationId = null) {
  let data = {};

  if (action === 'mark_all_notifications') {
    data = {
      action: 'mark_all_notifications',
    };
  } else if (action === 'mark_single_notification') {
    data = {
      action: 'mark_single_notification',
      notification_id: notificationId,
    };
  }

  return apiClient.create(notificationsRead, data, true);
}

// LinkedIn related functions
export function checkLinkedInConnectionStatus() {
  return apiClient.get(linkedinStatus, null, true);
}

export function connectLinkedIn(initiation = null) {
  let data = null;
  if (initiation) {
    data = { initiation };
  }
  return apiClient.get(linkedinConnect, data, true);
}

export function reconnectLinkedIn() {
  return apiClient.get(linkedinReconnect, null, true);
}

export function fetchAvailableInstagramConnections() {
  return apiClient.get(getAvailableInstagramConnections, null, true);
}

export function selectInstagramConnection(uuid) {
  return apiClient.create(customerSelectInstagramConnection, { uuid }, true);
}

export function fetchLinkedInAccountDetails(accountId) {
  return apiClient.get(getLinkedinAccountDetails(accountId), null, true);
}

export function registerLinkedInWebhook() {
  return apiClient.create(registerWebhookLinkedin, null, true);
}

// function to submit cred details
export function submitDetails(data) {
  return apiClient.create(detailsSubmit, data, true);
}

// Instagram Direct related functions
export function connectInstagramDirect() {
  return apiClient.create(instagramDirectConnect, null, true);
}

// Email/SendGrid related functions
export function saveEmailIntegrationSettings(data) {
  return apiClient.create(saveEmailSettings, data, true);
}
